import { BusinessHour, DayOfWeek } from '../types';
import { formatClockTime } from './shopTime';

/** Monday first, the way a shop's hours are posted in the US. */
const WEEK: [DayOfWeek, string][] = [
  [DayOfWeek.MONDAY, 'Mon'],
  [DayOfWeek.TUESDAY, 'Tue'],
  [DayOfWeek.WEDNESDAY, 'Wed'],
  [DayOfWeek.THURSDAY, 'Thu'],
  [DayOfWeek.FRIDAY, 'Fri'],
  [DayOfWeek.SATURDAY, 'Sat'],
  [DayOfWeek.SUNDAY, 'Sun'],
];

/** "7:30 AM – 6:00 PM", or null for a closed day. */
function openSpan(hour: BusinessHour | undefined): string | null {
  return hour?.open && hour.close
    ? `${formatClockTime(hour.open)} – ${formatClockTime(hour.close)}`
    : null;
}

/**
 * A week of hours as the lines on a shop's door: consecutive days with the
 * same hours share a line ("Mon–Fri · 9:00 AM – 5:00 PM"), and a shop open
 * the same hours every day reads "Open 7 days · …".
 */
export function weeklyHoursLines(hours: Partial<Record<DayOfWeek, BusinessHour>>): string[] {
  const runs: { from: string; to: string; span: string | null }[] = [];
  for (const [day, label] of WEEK) {
    const span = openSpan(hours[day]);
    const last = runs[runs.length - 1];
    if (last && last.span === span) last.to = label;
    else runs.push({ from: label, to: label, span });
  }

  if (runs.length === 1) {
    return [runs[0].span ? `Open 7 days · ${runs[0].span}` : 'Closed'];
  }
  return runs.map(({ from, to, span }) => `${from === to ? from : `${from}–${to}`} · ${span ?? 'Closed'}`);
}
